import { types } from 'mobx-state-tree';

const CartBasket = types.model('CartBasket', {
  id: types.string,
  text: types.string,
});

export default CartBasket;
